import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const TicketsContext = createContext();

export const useTickets = () => useContext(TicketsContext);

// Secciones fijas del tablero (estados posibles de un ticket)
export const TICKET_SECTIONS = [
  { id: 'reportados',  name: 'Reportados',  icon: 'alert-triangle' },
  { id: 'en-proceso',  name: 'En proceso',  icon: 'clock' },
  { id: 'en-prueba',   name: 'En prueba',   icon: 'flask' },
  { id: 'finalizado',  name: 'Finalizado',  icon: 'check-circle' },
  { id: 'reabiertos',  name: 'Reabiertos',  icon: 'refresh-cw' },
];

export const TicketsProvider = ({ children }) => {
  const navigate = useNavigate();

  // Estado de modales
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedTicket,    setSelectedTicket]     = useState(null);
  const [currentDepartment, setCurrentDepartment]  = useState(null);

  // Contexto para la creación: rol y estado inicial pre-seleccionado
  const [createForRoleId, setCreateForRoleId]   = useState(null);
  const [createForStatus, setCreateForStatus]   = useState('reportados');

  // Estado para el modal de edición
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editTicket,      setEditTicket]       = useState(null);

  /**
   * Abrir el modal de edición con un ticket.
   * @param {Object} ticket
   */
  const openTicketEdit = (ticket) => {
    setEditTicket(ticket);
    setIsEditModalOpen(true);
  };

  /**
   * Navegar al tablero de un departamento (role_id).
   * @param {number} roleId
   */
  const navigateToDepartment = (roleId) => {
    setCurrentDepartment(roleId);
    navigate(`/help/tickets/department/${roleId}`);
  };

  /**
   * Abrir el modal de detalle con un ticket.
   * @param {Object} ticket
   */
  const openTicketDetail = (ticket) => {
    setSelectedTicket(ticket);
    setIsDetailModalOpen(true);
  };

  const value = {
    sections: TICKET_SECTIONS,
    currentDepartment,
    setCurrentDepartment,
    navigateToDepartment,
    isCreateModalOpen,
    setIsCreateModalOpen,
    isDetailModalOpen,
    setIsDetailModalOpen,
    selectedTicket,
    setSelectedTicket,
    openTicketDetail,
    createForRoleId,
    setCreateForRoleId,
    createForStatus,
    setCreateForStatus,
    isEditModalOpen,
    setIsEditModalOpen,
    editTicket,
    setEditTicket,
    openTicketEdit,
  };

  return (
    <TicketsContext.Provider value={value}>
      {children}
    </TicketsContext.Provider>
  );
};

TicketsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};